export default __webpack_public_path__ + "static/media/home-icon-bottom-nav-mobile_b.58050575.webp";